export const GUIDE = 'GUIDE'
export const FAQ = 'FAQ'
export const OTHER = 'OTHER'
